import { render, staticRenderFns } from "./adjustDetails.vue?vue&type=template&id=771c9830&scoped=true"
import script from "./adjustDetails.vue?vue&type=script&lang=js"
export * from "./adjustDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c9830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771c9830')) {
      api.createRecord('771c9830', component.options)
    } else {
      api.reload('771c9830', component.options)
    }
    module.hot.accept("./adjustDetails.vue?vue&type=template&id=771c9830&scoped=true", function () {
      api.rerender('771c9830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/adjustDetails.vue"
export default component.exports